import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  width: {
    type: String,
    default: "30px",
  },
  height: {
    type: String,
    default: "30px",
  },
  color: {
    type: String,
    default: "#D9D9D9",
  },
},
  setup(__props) {

const props = __props



return { __sfc: true,props }
}

})